import { Route } from "react-router-dom";

import Plants from "./masterData/plants/Plants";
import PlantEdit from "./masterData/plants/PlantEdit";

import LineGroups from "./masterData/lineGroups/LineGroups";
import LineGroupCreate from "./masterData/lineGroups/LineGroupCreate";
import LineGroupEdit from "./masterData/lineGroups/LineGroupEdit";
import LineGroupMatrix from "./masterData/lineGroups/LineGroupMatrix";

import Lines from "./masterData/lines/Lines";
import LineCreate from "./masterData/lines/LineCreate";
import LineEdit from "./masterData/lines/LineEdit";
import LineKanbanEdit from "./masterData/lines/LineKanban";

import Evaluation from "./models/Evaluation";
import ModelEvaluationPage from "./models/model-evaluation/ModelEvaluationPage";
import Models from "./models/details/Models";
import ModelsStaging from "./models/staging/ModelsStaging";

import MaterialParallelCreate from "./masterData/materials/MaterialParallelCreate";
import MaterialParallelEdit from "./masterData/materials/MaterialParallelEdit";
import MaterialEdit from "./masterData/materials/MaterialEdit";
import MaterialPlantEdit from "./masterData/materials/MaterialPlantEdit";

import Processes from "./masterData/processes/Processes";

import People from "./masterData/people/People";
import PeopleCreate from "./masterData/people/PeopleCreate";
import PeopleEdit from "./masterData/people/PeopleEdit";
import PeopleDetailsStandalone from "./masterData/people/PeopleDetailsStandalone";

import BatchopGroups from "./masterData/batchopGroups/BatchopGroups";
import BatchopGroupCreate from "./masterData/batchopGroups/BatchopGroupCreate";
import BatchopGroupEdit from "./masterData/batchopGroups/BatchopGroupEdit";
import BatchopLocations from "./masterData/batchopLocations/BatchopLocations";
import BatchopLocationCreate from "./masterData/batchopLocations/BatchopLocationCreate";
import BatchopLocationEdit from "./masterData/batchopLocations/BatchopLocationEdit";

import StockLocations from "./masterData/stockLocations/StockLocations";
import StockLocationEdit from "./masterData/stockLocations/StockLocationEdit";

import Categories from "./masterData/categories/Categories";
import CategoryCreate from "./masterData/categories/CategoryCreate";

import OrganisationEdit from "./masterData/OrganisationEdit";
import Electricity from "./electricity/Electricity";

import Materials from "./masterData/materials/Materials";
import Operations from "./productionData/Operations";
import Productions from "./productionData/Productions";

export const getRoutes = ({ match: { url } }: { match: { url: string } }) => (
    <>
        <Route path={url} component={Plants} exact />
        <Route path={`${url}/resources/plants/:uuid?`} component={Plants} />
        <Route path={`${url}/resources/line_groups/:uuid?`} component={LineGroups} />
        <Route path={`${url}/resources/line_group/create`} component={LineGroupCreate} />
        <Route path={`${url}/resources/line_group/edit/:uuid`} component={LineGroupEdit} />
        <Route path={`${url}/resources/line_group/matrix/:uuid`} component={LineGroupMatrix} />
        <Route path={`${url}/resources/lines/:uuid?`} component={Lines} />
        <Route path={`${url}/resources/line/create`} component={LineCreate} />
        <Route path={`${url}/resources/line/edit/:uuid`} component={LineEdit} />
        <Route path={`${url}/resources/line/kanban/:uuid`} component={LineKanbanEdit} />
        <Route path={`${url}/resources/materials/:uuid?`} component={Materials} />
        <Route path={`${url}/resources/material/create`} component={MaterialParallelCreate} />
        <Route path={`${url}/resources/material_parallel/edit/:uuid?`} component={MaterialParallelEdit} />
        <Route path={`${url}/resources/material/edit/:uuid?`} component={MaterialEdit} />
        <Route
            path={`${url}/resources/material_plant/edit/:material_uuid/:plant_uuid?`}
            component={MaterialPlantEdit}
        />
        <Route path={`${url}/resources/plant/edit/:uuid?`} component={PlantEdit} />
        <Route path={`${url}/resources/processes/:uuid?`} component={Processes} />
        <Route path={`${url}/resources/people/:uuid?`} component={People} />
        <Route path={`${url}/resources/person/edit/:uuid`} component={PeopleEdit} />
        <Route path={`${url}/resources/person/create`} component={PeopleCreate} />
        <Route path={`${url}/resources/person/view/:uuid`} component={PeopleDetailsStandalone} />
        <Route path={`${url}/resources/batchop_groups/:uuid?`} component={BatchopGroups} />
        <Route path={`${url}/resources/batchop_group/create`} component={BatchopGroupCreate} />
        <Route path={`${url}/resources/batchop_group/edit/:uuid`} component={BatchopGroupEdit} />
        <Route path={`${url}/resources/batchop_locations/:uuid?`} component={BatchopLocations} />
        <Route path={`${url}/resources/batchop_location/create`} component={BatchopLocationCreate} />
        <Route path={`${url}/resources/batchop_location/edit/:uuid`} component={BatchopLocationEdit} />
        <Route path={`${url}/resources/stock_locations/:uuid?`} component={StockLocations} />
        <Route path={`${url}/resources/categories/:id?`} component={Categories} />
        <Route path={`${url}/resources/category/create`} component={CategoryCreate} />
        <Route path={`${url}/resources/category/edit/:id`} component={CategoryCreate} />
        <Route path={`${url}/resources/stock_location/edit/:uuid?`} component={StockLocationEdit} />
        <Route path={`${url}/resources/organisation`} component={OrganisationEdit} />
        <Route path={`${url}/production-data/operations`} component={Operations} />
        <Route path={`${url}/production-data/productions`} component={Productions} />
        <Route path={`${url}/models`} component={Models} exact />
        <Route path={`${url}/models/evaluation`} component={ModelEvaluationPage} />
        <Route path={`${url}/models/eval`} component={Evaluation} />
        <Route path={`${url}/models/staging`} component={ModelsStaging} />
        <Route path={`${url}/models/search`} component={Models} />
        <Route path={`${url}/electricity`} component={Electricity} />
    </>
);
